import { MONTHS, g } from "../revenue/format";

/** Simple closing-cash development bars (Jan → Dec), consistent with the design system. */
export default function CashChart({ months }) {
  const values = MONTHS.map((_, i) => g(months, i + 1)?.closing ?? 0);
  const maxAbs = Math.max(1, ...values.map((v) => Math.abs(v)));
  const min = Math.min(0, ...values);
  const hasNegative = min < 0;
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 mb-4" data-testid="cf-chart">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">Closing Cash Development</div>
      <div className="relative">
        <div className="flex items-end gap-1.5 h-32">
          {values.map((v, i) => (
            <div key={i} className="flex-1 flex flex-col justify-end h-full" data-testid={`cf-bar-${i + 1}`}>
              {hasNegative && v < 0 ? (
                <div className="h-full flex flex-col justify-start" style={{ paddingTop: `${(Math.max(...values) / (Math.max(...values) - min)) * 100}%` }}>
                  <div className="w-full bg-[#DC2626] rounded-t-sm" style={{ height: `${(Math.abs(v) / (Math.max(...values) - min)) * 100}%`, minHeight: 2 }} title={`${MONTHS[i]}: ${v.toLocaleString("sv-SE")} kr`} />
                </div>
              ) : (
                <div className="w-full bg-[#0052CC] rounded-t-sm" style={{ height: `${(Math.max(0, v) / maxAbs) * (hasNegative ? (Math.max(...values) / (Math.max(...values) - min)) : 1) * 100}%`, minHeight: 2 }} title={`${MONTHS[i]}: ${v.toLocaleString("sv-SE")} kr`} />
              )}
              <div className="text-[10px] text-center text-slate-400 mt-1">{MONTHS[i]}</div>
            </div>
          ))}
        </div>
        {hasNegative && (
          <div
            className="absolute left-0 right-0 border-t border-dashed border-slate-300"
            style={{ bottom: `calc(18px + ${(Math.max(...values) / (Math.max(...values) - min)) * 100}% * 0.0)` }}
          />
        )}
      </div>
    </div>
  );
}
